<app-inner-box>
  <app-subpage-header
    [title]="pageTitle"
    [subtitle]="headerSubtitle"
  >
    @if (countsReady) {
      <div class="order-status-counters">
        @for (key of statusKeys; track key) {
          <nz-statistic
            class="order-status-counters__item"
            [class.order-status-counters__item--muted]="key === 'Canceled'"
            [class.order-status-counters__item--open]="key === 'Open'"
            [class.order-status-counters__item--partly]="key === 'PartlyFinished'"
            [class.order-status-counters__item--finished]="key === 'Finished'"
            [nzTitle]="deliveryOrderStatuses[key]"
            [nzValue]="countFor(key)"
          ></nz-statistic>
        }
      </div>
    }
  </app-subpage-header>

  <div class="orders-actions">
    <button nz-button nzType="primary" (click)="addEditOrderModalComponent.showModal(null)">
      <i nz-icon nzType="plus-circle" nzTheme="outline"></i><span>Neu erstellen</span>
    </button>
    <app-download-documents [documentKeys]="selectedDocumentKeys"></app-download-documents>
  </div>

  @switch (selectedOrderType) {
    @case (orderTypes.MIXED) {
      <app-orders-list
        #listComponent
        [orderType]="selectedOrderType"
        (selectedDocumentKeysChange)="onSelectedDocumentKeysChange($event)"
        (statusCountsChange)="onStatusCountsChange($event)"
      ></app-orders-list>
    }
    @case (orderTypes.Bagable) {
      <app-orders-list
        #listComponent
        [orderType]="selectedOrderType"
        (selectedDocumentKeysChange)="onSelectedDocumentKeysChange($event)"
        (statusCountsChange)="onStatusCountsChange($event)"
      ></app-orders-list>
    }
    @case (orderTypes.NonPacking) {
      <app-orders-list
        #listComponent
        [orderType]="selectedOrderType"
        (selectedDocumentKeysChange)="onSelectedDocumentKeysChange($event)"
        (statusCountsChange)="onStatusCountsChange($event)"
      ></app-orders-list>
    }
  }
</app-inner-box>

<app-add-edit-order-modal
  (refresh)="listComponent.onRefreshList()"
  #addEditOrderModalComponent
  [orderType]="selectedOrderType"
></app-add-edit-order-modal>
